import React, { useState } from "react";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import { useNavigate } from "react-router-dom";

function ForgotPasswordThree({ props }) {
  const [loading, setLoading] = useState(false);
   const [cPassword, setCPassword] = useState("")
   const navigate = useNavigate()
  function formValidations() {
    if (props.newPassword.length < 1) {
      toast.error("Password is required");
      return false;
    }
    if (props.newPassword === cPassword) {
   
    }else{
      toast.error("Password does not match");
      return false;
    }

    return true;
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = await formValidations();

    if (isValid) {
      if (props.type === "user") {
        const data = {
          email: props.email,
          // otp: parseInt(props.otp, 10),
          otp: props.otp,
          newPassword: props.newPassword
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/users/user-reset-password`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("New Password Set");
         
            navigate("/user-register")
          } else {
            toast.error(json.message);
            props.setIndex(2);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "agent" || props.type === "tc") {
        const agentVendorType = props.type === "tc"? "Transaction Coordinator": props.aqdasYes
        const data = {
          agentEmail: props.email,
          // otp: parseInt(props.otp, 10),
          otp: props.otp,
          newPassword: props.newPassword,
          agentVendorType
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/agents/agent-reset-password`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("New Password Set");
         if(props.type === "agent"){
          navigate("/agent-register")
         }
         if(props.type === "tc"){
          navigate("/tc-register")
         }
          
          } else {
            toast.error(json.message);
            props.setIndex(2);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "advertiser") {
        const data = {
          email: props.email,
          // otp: parseInt(props.otp, 10),
          otp: props.otp,
          newPassword: props.newPassword
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/advertiser/advertiser-reset-password`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("New Password Set");
         
            navigate("/advertiser-register")
          } else {
            toast.error(json.message);
            props.setIndex(2);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
      if (props.type === "la") {
        const data = {
          email: props.email,
          // otp: parseInt(props.otp, 10),
          otp: props.otp,
          newPassword: props.newPassword
        };
        setLoading(true);
        try {
          const response = await fetch(
            `${API}/auth/lendingAgents/lendingAgents-reset-password`,
            {
              method: "POST",
              body: JSON.stringify(data),
              headers: {
                "Content-Type": "Application/json",
              },
            }
          );
          const json = await response.json()
          if (response.ok) {
            toast.success("New Password Set");
         
            navigate("/la-register")
          } else {
            toast.error(json.message);
            props.setIndex(2);
          }
        } catch (error) {
          toast.error(error.message);
        } finally {
          setLoading(false);
        }
      }
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit} className="agent-register-form">
        <input
          type="password"
          className="form-control agent-register-input-field"
          id="exampleInputEmail1"
          placeholder="New Password"
          aria-describedby="emailHelp"
          onChange={(e) => props.setPassword(e.target.value)}
        />
        <input
          type="password"
          className="form-control agent-register-input-field"
          id="exampleInputEmail1"
          placeholder="Confirm Password"
          aria-describedby="emailHelp"
          onChange={(e) => setCPassword(e.target.value)}
        />

        {loading ? (
          <span className="btn agent-register-button">Sending...</span>
        ) : (
          <button type="submit" className="btn agent-register-button">
            Confirm
          </button>
        )}
      </form>
    </>
  );
}

export default ForgotPasswordThree;
